/* eslint-disable */
export const DOCKETS_LIST_SETTINGS = `[DOCKETS] LIST SETTINGS`;
